import { type DistributeTaggedUnion } from '@autone/utils';

import { type EditInSeasonAggregationDimensionIdentifier } from './edit-in-season-aggregation.types';
import { type EditPreSeasonAggregationDimensionIdentifier } from './edit-pre-season-aggregation.types';
import { type InSeasonAggregationListItem } from './get-in-season-aggregations-list.types';
import { type PreSeasonAggregationListItem } from './get-pre-season-aggregations-list.types';

export const PRODUCT_DIMENSION_ATTRIBUTES = [
  'all_products',
  'department',
  'sub_department',
  'style',
  'color',
  'material',
  'gender',
  'brand',
  'season',
  'event',
  'collection_type',
  'manufacturer',
  'class',
  'sub_class',
  'product_group',
  'product',
  'size',
  'sku',
  'size_run',
] as const;

export type ProductDimensionAttribute =
  (typeof PRODUCT_DIMENSION_ATTRIBUTES)[number];

export const GEOGRAPHIC_DIMENSION_ATTRIBUTES = [
  'all_locations',
  'region',
  'country',
  'location_type',
  'location',
  'location_group',
  'location_cluster',
] as const;

export type GeographicDimensionAttribute =
  (typeof GEOGRAPHIC_DIMENSION_ATTRIBUTES)[number];

export type FrontendAssortmentDimensionAttribute =
  | ProductDimensionAttribute
  | GeographicDimensionAttribute;

export type FrontendAssortmentDimensionAttributeAggregation = [
  ProductDimensionAttribute,
  GeographicDimensionAttribute,
];

export type FrontendAssortmentRowDimension =
  | DistributeTaggedUnion<
      | InSeasonAggregationListItem['dimensions'][number]
      | PreSeasonAggregationListItem['dimensions'][number],
      'name'
    >
  | {
      name: 'all_products';
      model: null;
    }
  | {
      name: 'all_locations';
      model: null;
    };

export type FrontendAssortmentRowDimensionIdentifier =
  | DistributeTaggedUnion<
      | EditInSeasonAggregationDimensionIdentifier
      | EditPreSeasonAggregationDimensionIdentifier,
      'dimension'
    >
  | {
      dimension: 'all_products';
      model: null;
    }
  | {
      dimension: 'all_locations';
      model: null;
    };
